import { EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { IconsContext } from "@progress/kendo-react-common";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "@progress/kendo-font-icons/dist/index.css";
import "./App.scss";
import { pca } from "./config/authConfig";

// Default to using the first account if no account is active on page load
if (!pca.getActiveAccount() && pca.getAllAccounts().length > 0) {
  pca.setActiveAccount(pca.getAllAccounts()[0]);
}

pca.addEventCallback((event: any) => {
  const { eventType, payload } = event;

  if (
    payload?.account &&
    (eventType === EventType.LOGIN_SUCCESS || eventType === EventType.ACQUIRE_TOKEN_SUCCESS)
  ) {
    pca.setActiveAccount(payload.account);
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // globally default to 20 seconds
      staleTime: 1000 * 20,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <MsalProvider instance={pca}>
      <QueryClientProvider client={queryClient}>
        <CookiesProvider>
          <IconsContext.Provider value={{ type: "font" }}>
            <ReactQueryDevtools buttonPosition="top-right" />
            <App />
          </IconsContext.Provider>
        </CookiesProvider>
      </QueryClientProvider>
    </MsalProvider>
  </BrowserRouter>,
);
